import { defineComponent, h, PropType, watch } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { hole } from '../../set-button-state';
import hole_svg from '../../../assets/img/SVG_icons/Top/advanced_operation/hole.svg';
import { img } from '@phi/components';
import HoleTooltip from './HoleTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const HoleIcon = hole_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    data() {
        return {
            callback: undefined as ReturnType<typeof hole>,
        };
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Hole';
        },

        disabled() {
            return !this.state.loaded
                || this.state.selected_faces_count === 0
                || !this.callback;
        },
    },

    mounted() {
        watch(() => this.state.selected_faces_count, () => {
            this.callback = hole();
        });
    },

    methods: {
        onClick() {
            if (this.disabled) return;
            if (this.callback) this.callback();
        },
    },

    render() {
        return h(BarButton, {
            disabled: this.disabled,
            selected: this.state.tut_stage === 4,
            active: false,
            id: 'hole-button',
            tippy: 'bottom',
            wrapperId: 'hole-wrapper',
            onClick: this.onClick,
            help: 'hole',
        }, {
            label: () => 'Hole',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(hole_svg, this.alt),
            tooltip: HoleTooltip,
        });
    },
});
